import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Select, Collapse, Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const PaymentMethodTableFilter = (props) => {
  const [paymentSelect, setPaymentSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    getPaymentSets();
  }, []);

  const getPaymentSets = () => {
    setPaymentSelect({ data: [], loading: true });

    RequestHandler.get(`/PaymentSet?$select=id,name`).then((res) => {
      let response = res.value;
      response.unshift({ id: null, name: "Varsayılan" });
      setPaymentSelect({ data: res.value, loading: false });
    });
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.name) {
        conditions.push(odata.contains("name", values.name));
      }

      if (values.paymentSetId) {
        if (values.paymentSetId.startsWith("_")) {
          const searchValue = values.paymentSetId.slice(1);
          conditions.push(odata.contains("paymentSetName", searchValue));
        } else {
          conditions.push(`paymentSetId eq ${values.paymentSetId}`);
        }
      }

      if (values.paymentSetId === null) {
        conditions.push(`paymentSetId eq ${values.paymentSetId}`);
      }

      if (conditions.length !== 0) {
        query = "&$filter=" + conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label={props?.nameKey + " Adı :"} name="name">
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  md={12}
                  lg={6}
                  hidden={props?.useComponentForPolicy}
                >
                  <Form.Item name="paymentSetId" label="Ödeme Seti :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={paymentSelect.loading}
                    >
                      {paymentSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default PaymentMethodTableFilter;
